<script>
  export default {
    props: {
      isShowFilter: {
        type: Boolean,
        default: false
      }
    },
    data() {
      return {
        
      }
    },
    computed: {
      // data: {
      //   get() {
      //     return this.value
      //   },
      //   set(value) {
      //     this.$emit('input', value)
      //   },
      // },
    },
    watch: {
      isShowFilter: function(newValue, oldValue) {
        if (newValue) {
          // document.querySelector('input').focus()
          document.body.style.overflow = "hidden";
        }else {
          document.body.removeAttribute("style")
        }
      }
    },
    methods: {
      // changeFilter(val) {
      //   this.$emit('changeFilter', val)
      // }
      onShowFilterMenu(status) {
        this.$emit('showFilterMenu', status)
      }
    }
  }
</script>
<template>
  <div :class="[$style.baseFilterBox, { isShow: isShowFilter }]">
    <div class="d-md-none d-block">
      <BaseButton
        class="isText d-flex ml-auto mb-4"
        @click="onShowFilterMenu(false)"
      >
        <i style="font-size: 18px;" class="icomoon icon-cross"></i>
      </BaseButton>
      <h4>篩選</h4>
      <el-divider></el-divider>
    </div>
    <slot/>
    
  </div>
</template>
<style lang="scss" module>
  .baseFilterBox {
    @include max-md {
      @include var-height(100);
      display: none;
      position: fixed;
      left: 0;
      z-index: 2000;
      padding: 17px 19px 12rem;
      // padding-top: 1rem;
      // padding-right: 15px;
      // padding-bottom: 8rem;
      overflow-y: auto;
      // background: hsla(0,0%,100%,.94);
      // backdrop-filter: blur(4px);
      width: 100%;
      top: 0;
      &:before {
        content: '';
        position: fixed;
        top: 0;
        left: 0;
        width: 100%;
        height: 100vh;
        background: hsla(0,0%,100%,.94);
        filter: blur(4px);
        z-index: -1;
      }
      &__btn {
        position: fixed;
        box-shadow: 0px -2px 5px #1A1D000B;
        padding: 1.25rem 2.5rem 1.87rem;
        width: 100vw;
        left: 0;
        bottom: 0;
        // bottom: -94px;
        transition: bottom .3s;
        background: #FFF;
        z-index: 2001;
      }
      &:global {
        &.isShow {
          display: block;
        }
      }
    }
  }
</style>
